import t from "@/lang/lang";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { MatchOneToOneTable } from "@/services/backend/business-central/components/match-one-to-one-table";
import { useActiveCompany } from "@/shared/lib/active-company/active-company-provider";
import { useBusinessCentralMatchOneToOneShowQuery } from "@/services/backend/business-central/api/match-one-to-one-api";
import { MatchType } from "../types/match-type";
import { MatchOneToOneCreateDialog } from "./match-one-to-one-create-dialog";

export function ServiceKindMatchesCard() {
  const { companyId: activeCompanyId } = useActiveCompany();
  // The resources to match against belong to the Business Central company
  // matched to the active GSM company.
  const { data: match } = useBusinessCentralMatchOneToOneShowQuery({
    type: MatchType.CompanyToCompany,
    id: activeCompanyId,
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Dienstleistungen")}</CardTitle>
        <CardDescription>
          {t(
            "Hier werden die Dienstleistungen aus dem GSM mit den Ressourcen in Business Central verknüpft.",
          )}
        </CardDescription>
        <CardAction>
          <MatchOneToOneCreateDialog
            type={MatchType.ServiceKindToResource}
            bcCompanyId={match?.bcId ?? ""}
          />
        </CardAction>
      </CardHeader>
      <CardContent>
        <MatchOneToOneTable
          type={MatchType.ServiceKindToResource}
          bcCompanyId={match?.bcId ?? ""}
        />
      </CardContent>
    </Card>
  );
}
